export default __webpack_public_path__ + "images/2Q.fdb8951.png";